import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4A5D23', // Deep forest green
      light: '#6B8E23', // Sage green
      dark: '#28351A', // Rich charcoal green
    },
    secondary: {
      main: '#A78B61', // Soft muted gold accent
      light: '#D9C6A3',
      dark: '#735B35',
    },
    background: {
      default: '#F5F5F2', // Warm off-white background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#111827', // Charcoal
      secondary: '#4B5563', // Muted gray
    },
  },
  typography: {
    fontFamily:
      '"Poppins", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.04em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.03em',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.08em',
    },
  },
  shape: {
    borderRadius: 18,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 24,
          paddingBlock: 10,
        },
        containedPrimary: {
          boxShadow: '0 16px 40px rgba(74, 93, 35, 0.35)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
        },
      },
    },
  },
});

export default theme;

